import { render, staticRenderFns } from "./ThePaymentEdit.vue?vue&type=template&id=12cff1b7&"
import script from "./ThePaymentEdit.vue?vue&type=script&lang=js&"
export * from "./ThePaymentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ThePaymentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports